import React from 'react';
import './token-redemption-pay-details.scss';
import { TokenRedemptionType } from 'constants/redemption';
import TokenRedemptionParams from '../TokenRedemptionParams';
import Step from 'modules/step';
import { BlockchainTransactionInfo, TokenStatusBadge } from 'components';

interface ITokenRedemptionPayDetails {
  redemptionType: TokenRedemptionType;
  asset: any;
}

export default function TokenRedemptionPayDetails({
  redemptionType,
  asset,
}: ITokenRedemptionPayDetails) {
  return (
    <div className="token-redemption-pay-details">
      <div className="token-redemption-pay-details__left">
        <div className="mb_32">
          <Step
            steps={[
              { title: 'Инициация погашения' },
              { title: 'Оплата', active: true },
              { title: 'Подтверждение погашения' },
            ]}
          />
        </div>
        <p className="p p_font-size_24 p_font-weight_light mb_8">
          {`Погашение ${asset.actualCount} токенов ${asset.issuingInfo.tokenName}`}
        </p>
        <TokenStatusBadge
          text="Требуется подтвердить оплату"
          variant={asset.isIssuer ? 'yellow' : 'grey'}
        />
      </div>
      <div className="token-redemption-pay-details__right">
        <p className="p p_bold mb_24">Параметры погашения</p>
        <p className="p p_font-size_12 p_color_light-grey">ID транзакции</p>
        <div className="mb_32">
          <BlockchainTransactionInfo hash={asset.blockchainTransactionId} />
        </div>
        <TokenRedemptionParams redemptionType={redemptionType} asset={asset} />
      </div>
    </div>
  );
}
